import { GENERATE_WORKER_TIMESHEET_HOURS, GENERATE_WORKER_TIMESHEET_HOURS_ERROR, GET_WORKER_PROJECT_LIST, GET_WORKER_PROJECT_LIST_ERROR, GET_WORKER_TIMESHEET_BULK_LIST, GET_WORKER_TIMESHEET_BULK_LIST_ERROR, GET_WORKER_TIMESHEET_HOURS, GET_WORKER_TIMESHEET_HOURS_ERROR, GET_WORKER_TIMESHEET_ID, GET_WORKER_TIMESHEET_ID_ERROR, GET_WORKER_TIMESHEET_LIST, GET_WORKER_TIMESHEET_LIST_ERROR, GET_WORKER_TIMESHEET_STATUS_LIST, GET_WORKER_TIMESHEET_STATUS_LIST_ERROR, GET_WORKER_TIMESHEET_WORKER_RATES, GET_WORKER_TIMESHEET_WORKER_RATES_ERROR, RESET_WORKER_TIMESHEET_DETAILS, RESET_WORKER_TIMESHEET_HOUR_DETAILS, SAVE_WORKER_TIMESHEET, SAVE_WORKER_TIMESHEET_ERROR } from "../../actions/types";

const initialState = {
    timesheetWorkerList: [],
    timesheetWorkerStatusList: [],
    timesheetWorkerActionList: [],

    timesheetDetail: {},
    timesheetScheduleList: [],
    timesheetWorkerRates: {},
    timesheetHourDetail: {},

    workerProjectListForTimesheet: [],
}

export const workerTimesheet = (state = initialState, action) => {
    switch (action.type) {

        case GET_WORKER_TIMESHEET_STATUS_LIST:
            return {
                ...state,
                timesheetWorkerStatusList: action.payload.data,
            };
        case GET_WORKER_TIMESHEET_STATUS_LIST_ERROR:
            return {
                ...state,
                timesheetWorkerStatusList: [],
            };
        case GET_WORKER_TIMESHEET_LIST:
            return {
                ...state,
                timesheetWorkerList: action.payload.data,
            };
        case GET_WORKER_TIMESHEET_LIST_ERROR:
            return {
                ...state,
                timesheetWorkerList: [],
            };
        case GET_WORKER_TIMESHEET_BULK_LIST:
            return {
                ...state,
                timesheetWorkerActionList: action.payload.data,
            }
        case GET_WORKER_TIMESHEET_BULK_LIST_ERROR:
            return {
                ...state,
                timesheetWorkerActionList: [],
            }
        case RESET_WORKER_TIMESHEET_DETAILS:
            return {
                ...state,
                timesheetDetail: {},
                timesheetScheduleList: [],
                timesheetWorkerActionList: [],
            }

        case SAVE_WORKER_TIMESHEET:
            return {
                ...state,
                timesheetDetail: action.payload.data,
            }
        // case SAVE_WORKER_TIMESHEET_ERROR:
        //     return {
        //         ...state,
        //         timesheetDetail: {}
        //     }
        case GET_WORKER_TIMESHEET_ID:
            return {
                ...state,
                timesheetDetail: action.payload.data,
            };
        case GET_WORKER_TIMESHEET_ID_ERROR:
            return {
                ...state,
                timesheetDetail: {},
            };
        case GENERATE_WORKER_TIMESHEET_HOURS:
            return {
                ...state,
                timesheetScheduleList: action.payload.data,
            }
        case GENERATE_WORKER_TIMESHEET_HOURS_ERROR: 
            return {
                ...state,
                timesheetScheduleList: [],
            }
        case GET_WORKER_TIMESHEET_WORKER_RATES:
            return {
                ...state,
                timesheetWorkerRates: action.payload.data,
            }
        case GET_WORKER_TIMESHEET_WORKER_RATES_ERROR:
            return {
                ...state,
                timesheetWorkerRates: {},
            }
        
        case GET_WORKER_TIMESHEET_HOURS: 
            return {
                ...state,
                timesheetHourDetail: action.payload.data,
            }
        case GET_WORKER_TIMESHEET_HOURS_ERROR: 
            return {
                ...state,
                timesheetHourDetail: {},
            }        
        case RESET_WORKER_TIMESHEET_HOUR_DETAILS:
            return {
                ...state,
                timesheetHourDetail: {},
            }

        case GET_WORKER_PROJECT_LIST: {
            return {
                ...state,
                workerProjectListForTimesheet: action.payload.data,
            }
        }
        case GET_WORKER_PROJECT_LIST_ERROR: {
            return {
                ...state,
                workerProjectListForTimesheet: [],
            }
        }

        default:
            return state;
    }
}